






















import Vue, { PropOptions } from 'vue';
import util from '@/components/util';
import { VExtensionDevice } from '@/class/models/views/account';
import API from '@/api/common';
import * as models from '@/class/models/views/account';

export default Vue.extend({
  name: 'ModalLicenceApplication',
  components: { ...util},
  props: {
    selectedYear: Number,
    // currentYear: Number,
    // viewableYear: Number,
    viewablePeriod: String,
    deviceList: Array as PropOptions<VExtensionDevice[]>,
  },
  data() {
    return { accountData: {} as models.IAccount }
  },
  async mounted() {
    const api = new API();
    const res = await api.get<models.IAccount>('account');

    if (res.result) {
      this.accountData = res.data;
    }
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickChangeOptionYear() {
      this.$emit('changeOption');
    },
  },
  computed: {
    clientCount(): number {
      return this.deviceList.filter((v) => v.extensionFlag).length;
    },
    hasUnassociatedDevice(): boolean {
      // 選択デバイスのうち、linkedUsersが0件のデバイスがあればtrue
      return this.deviceList.some((v) => v.extensionFlag && !v.linkedUsers.length);
    },
  },
});
